<template>
<div>
   <div class="bg_gray"></div>
   <div class="onlineRetailers">
        <header class="head"></header>
        <nav class="bigBox">
            <div class="box" v-for="(item,index) in data" :key="index" @click="seeDetails(item)">
                <div class="img">
                    <van-image
                          lazy-load
                          :src="item.img"
                    >
                        <template v-slot:loading>
                          <van-loading type="spinner" size="20" />
                        </template>
                         <template v-slot:error>加载失败</template>
                    </van-image>
                </div>
                <h2 class="title van-multi-ellipsis--l2">{{item.title}}</h2>
                 <div class="cost">基础工费: <span class="text">{{cost.Basics}}元/g</span>  附加费: <span class="text">{{cost.additional}}元/g</span></div>
                 <div class="dataInfo">
                    <div class="weight">克重: {{item.weight.toFixed(2)}}g </div>
                    <div class="save">库存: {{item.save}} </div>
                 </div>
                <div class="money text">  ¥{{(Number(item.weight * pricehj) +  Number(cost.Basics * item.weight)).toFixed(2)}}</div>
            </div>
            <div class="finished">一  没有更多了 一</div>
        </nav>
   </div>
   <footer class="foot">
             <div class="flex-around">
                <div @click="linkMall">
                    <div class="footerboximg"><img src="@/assets/images/icon_mall-sel@2x.png" alt="" /></div>         
                    <div class="footerText">商城</div>
                 </div>
                  <div @click="linkCart">
                    <div class="footerboximg"><img src="@/assets/images/icon_trolley_nor@2x.png" alt="" /></div>         
                    <div class="footerText">购物车</div>
                 </div>
                  <div @click="linkMy">
                     <div class="footerboximg"><img src="@/assets/images/icon_personal_nor@2x.png" alt="" /></div>
                     <div class="footerText">我的</div>
                 </div>
            </div>
    </footer>
</div>
 
</template>

<script>
import Stomp from 'stompjs'
export default {
        data() {
            return {
                // 商品数据
                data:[
                    {
                        weight:50,
                        save:5,
                        title:`Au9999 投资黄金金条足金50克+简易包装`,
                        img:'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimage.bankbbs.com%2F813180_ZGGSYHXYK_20210423183422_7.png&refer=http%3A%2F%2Fimage.bankbbs.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1663397385&t=9ec25c92b7484dabbed545f5fac0d05d'
                        },
                    {
                        weight:10,
                        save:5,
                        title:`Au9999 投资黄金金条足金10克+简易包装`,
                        img:'https://img0.baidu.com/it/u=4052576286,3281837590&fm=253&fmt=auto&app=138&f=JPEG?w=667&h=500'
                        },
                    {
                        weight:200,
                        save:5,
                        title:`Au9999 投资黄金金条足金200克+简易包装`,
                        img:'https://img0.baidu.com/it/u=4052576286,3281837590&fm=253&fmt=auto&app=138&f=JPEG?w=667&h=500'
                        },
                    {
                        weight:20,
                        save:5,
                        title:`Au9999 投资黄金金条足金20克+简易包装`,
                        img:'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimage.bankbbs.com%2F813180_ZGGSYHXYK_20210423183422_7.png&refer=http%3A%2F%2Fimage.bankbbs.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1663397385&t=9ec25c92b7484dabbed545f5fac0d05d'
                        },                    
                    {
                        weight:20,
                        save:5,
                        title:`Au9999 投资黄金金条足金20克+简易包装`,
                        img:'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimage.bankbbs.com%2F813180_ZGGSYHXYK_20210423183422_7.png&refer=http%3A%2F%2Fimage.bankbbs.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1663397385&t=9ec25c92b7484dabbed545f5fac0d05d'
                        },
                    {
                        weight:20,
                        save:5,
                        title:`Au9999 投资黄金金条足金20克+简易包装`,
                        img:'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimage.bankbbs.com%2F813180_ZGGSYHXYK_20210423183422_7.png&refer=http%3A%2F%2Fimage.bankbbs.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1663397385&t=9ec25c92b7484dabbed545f5fac0d05d'
                        },
                ],
                // 基础工费,附加费
                cost:{
                    Basics:2.5,
                    additional:0
                },
                pricehj:0,
                priceboj:0,
                pricebaj:0,
                pricebaiy:0,
                initPrice:{
                    huangjin:'huangjin9999',
                    baiyin:'baiyin9999',
                    bajin:"bajin9996",
                    bojin:"bojin9996"
                },
                client: {},
                // 所有商品数据
                allpro:[],
                // 首次加载的数据
                initDatalist: [],
                // 是否开盘
                trade_: false,
                // 提交时间
                postTime:'',
                totalMoney:0,
            }
        },
        mounted(){
            this.connect()
        },
        watch:{
                allpro:function(){
                     if(this.initPrice != ''){
                         this.updatearr(this.initPrice)
                     }
                },
                pricehj:function(newVal,oldVal){
                }
        },
        methods:{
            // 查看商品详情
            seeDetails(item){
                localStorage.setItem('commodity', JSON.stringify(item))
                this.$router.push({
                    name:'productDetails',
                })
            },
            linkMall(){
              this.$router.push({name:"shoppingMall"})
            },      
            linkCart(){
              this.$router.push({name:"shoppingCart"})
            },      
            linkMy(){
              this.$router.push({name:"shoppingMy"})
            },
            unzip(b64Data) {
              let strData = atob(b64Data);
              const charData = strData.split("").map(function(x) {
                return x.charCodeAt(0);
              });
              const binData = new Uint8Array(charData);
              const data = pako.inflate(binData);
              strData = String.fromCharCode.apply(null, new Uint16Array(data));
              return decodeURIComponent(escape(strData));
            },
            onConnected() {
              const topic = "/price/all";
              this.client.subscribe(topic, this.responseCallback, this.onFailed);
            },
            connect() {
               this.client = Stomp.over(new WebSocket(process.env.VUE_APP_WS));
              // ---初始化mqtt客户端，并连接mqtt服务
              const headers = {
                login: "username",
                passcode: "password"
              };
              this.client.connect(headers, this.onConnected, this.onFailed);
              this.client.debug = null;
            },
            onFailed(frame) {
              console.log("错误: " + frame);
                  if (!this.client.connected) {
                setTimeout(() => {
                  console.log('11');
                  this.connect();
                }, 1000);
              }
            },
            deepMerge(...objs) {
                 const than = this
                 const result = Object.create(null)
                 objs.forEach(obj => {
                   if (obj) {
                     Object.keys(obj).forEach(key => {
                       const val = obj[key]
                       if (than.isPlainObject(val)) {
                         // 递归
                         if (than.isPlainObject(result[key])) {
                           result[key] = than.deepMerge(result[key], val)
                         } else {
                           result[key] = than.deepMerge(val)
                         }
                       } else {
                           //  数组也要重新赋值  不然依然会引用到其他的
                         if (Array.isArray(val)) {
                           result[key] = [...val]
                         } else {
                           result[key] = val
                         }
                       }
                     })
                   }
                 })
                 return result
            },
            isPlainObject(val) {
              const toString = Object.prototype.toString
              return toString.call(val) === '[object Object]'
            },
            responseCallback (frame) {
              this.allpro = []
              const resbody = eval('['+this.unzip(frame.body)+']')[0]
              const parse_res = JSON.parse(JSON.stringify(resbody));
              this.trade_ = resbody.trade;
              this.postTime = resbody.time
              // console.log('postTime1',this.postTime);
              if(this.firstloadData){
                this.initDatalist = resbody
                this.firstloadData = false
                for(const i in this.initDatalist){
                  if(this.initDatalist[i]['prices'] != undefined){

                    this.allpro.push(this.initDatalist[i]['prices'])
                  }
                }
              }else{
                this.initDatalist = this.deepMerge(this.initDatalist,parse_res)
                for(const i in this.initDatalist){
                  if(this.initDatalist[i]['prices'] != undefined){
                    this.allpro.push(this.initDatalist[i]['prices'])
                      }
                   }
                }
            },
            // 价格变动更新视图
            pricenew(obj){
              this.allpro.find((x)=>{
                if(x[obj.huangjin]){
                  this.pricehj = x[obj.huangjin]['xiaoshou']
                }        
                if(x[obj.baiyin]){
                  this.pricebaiy = x[obj.baiyin]['xiaoshou']
                }        
                if(x[obj.bajin]){
                  this.pricebaj = x[obj.bajin]['xiaoshou']
                }        
                if(x[obj.bojin]){
                  this.priceboj = x[obj.bojin]['xiaoshou']
                }
              })
            },
            // 更新数组
            updatearr(obj){
                    this.pricenew(obj)
            },
        }
}
</script>

<style lang="scss" scoped>
.bg_gray {
  background: #970401;;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}
::v-deep{
    .van-image{
        width: 100%;
        height: 100%;
}
}
.onlineRetailers{
  position: relative;
  z-index: 1;
  width: 100%;
  padding: 0 0  60px 0;
  .bigBox{
  padding: 20px 30px 60px;
        .box{ 
           display: inline-block;
           width: 330px;
           height: 600px;
           background-color: #fff;
           margin: 0 30px 30px 0;
           border-radius: 24px;
           padding: 16px;
           .img{
            width: 100%;
            height: 280px;
            border-radius: 16px;
            overflow: hidden;
           }
           .title{
            font-size: 28px;
            font-weight: 400;
            color: #242424;
            margin: 22px 0 10px;
           }
           .cost{
            width: 100%;
            padding: 10px 0px 10px 8px;
            background-color: #fff1f1;
            border-radius: 10px;
           }
            .dataInfo{
                    width: 100%;
                    color: #a2a2a2;
                    display: flex;
                    justify-content: space-between;
                    font-size: 24px;
                    margin: 10px 0 20px;
            }
            .money{
                font-size: 32px;
                font-weight: 600;
            }
         }
         .box:nth-child(even){
            margin-right: 0px;
         }
         .finished{
            color: #fff;
            width: 100%;
            text-align: center;
            margin-top: 40px;
         }
  }
 .text{
    color: #ff553d;
 }
}
.foot{
    width: 100%;
    height: 100px;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    z-index: 1;
    border-top: 1px solid #E9E9E9;
    font-size: 22px;
    color: #242424;
    .footerboximg {
    margin: 10px auto 0px;
    width: 48px;
    height: 48px;
    
    }
    .footerText{
        text-align: center;
    }
}
.head{
    height: 464px;
    width: 100%;
    background: url('~@/assets/images/pic_shop_top@2x.png') no-repeat;
    background-size: 100% 100%;  
}
</style>